import * as types from 'constants/ActionTypes';
import { DEALER_STATUS } from 'constants/StatusConstants';
import { GET_MODAL_DEALERS_SUCCESS, GET_PAGINATED_DEALERS_FETCH_SUCCESS } from 'modules/dealers/actionTypes';
import { uniq } from 'utils/ObjectUtils';
import { createReducer } from 'utils/ReduxUtils';

const { ACTIVE } = DEALER_STATUS;

// Contains all dealer ids not link to any extension (ie all default dealers)
const initialState = [];

const initialStateReducer = () => initialState;

/**
 * @param {Array<string>} state
 * @param {import('modules/dealers/types').GenericDealersActionPage} action
 * @returns {Array<string>}
 */
const fetchDealersSuccessReducer = (state, { payload }) =>
  uniq([...state, ...payload.content.filter(({ status = ACTIVE }) => status === ACTIVE).map(dealer => dealer.id)]);

const fetchDealerSuccessReducer = (state, { payload: dealer }) =>
  fetchDealersSuccessReducer(state, { payload: { content: [dealer] } });

const dealerSuccessReducer = (state, { payload: dealer }) => uniq([...state, dealer.id]);

export default createReducer(initialState, {
  [types.FETCH_DEALER_SUCCESS]: dealerSuccessReducer,
  [types.CREATE_DEALER_SUCCESS]: dealerSuccessReducer,
  [types.FETCH_DEALER_SUCCESS]: fetchDealerSuccessReducer,
  [types.FETCH_DEALERS_SELECT_FAILURE]: initialStateReducer,
  [types.FETCH_DEALERS_SELECT_SUCCESS]: fetchDealersSuccessReducer,
  [GET_MODAL_DEALERS_SUCCESS]: fetchDealersSuccessReducer,
  [GET_PAGINATED_DEALERS_FETCH_SUCCESS]: fetchDealersSuccessReducer,
});
